// extracted by mini-css-extract-plugin
module.exports = {"locationDate":"LocationDate_locationDate__1k891","day":"LocationDate_day__3rt0C","month":"LocationDate_month__3LBy9","year":"LocationDate_year__1xAz5"};